export function asBoolean(value: boolean): string {
  return value ? "yes" : "no";
}
